import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import pdf from './pdfmake-custom'
import printDoc from '@/plugins/print'

Vue.use(
  Vuetify, {
    iconfont: 'md mdi'
  }
)

export default {
  install (Vue) {
    Vue.pdfMake = pdf.pdfMake
    Vue.printDoc = printDoc

    Vue.prototype.pdfMake = pdf.pdfMake
    Vue.prototype.printDoc = printDoc
  }
}
